export enum TargetActiveOn {
  ON_INVOICE='invoice',
  ON_DELIVERY='delivery',
  ON_ORDER='order',
}
